import { useLayoutEffect, useState } from 'react';

export const useCommitted = <T>(read: () => T) => {
  const [cell] = useState(() => {
    let current: T | undefined;
    return {
      get: () => current,
      set: (next: T) => {
        current = next;
      },
    };
  });
  useLayoutEffect(() => {
    cell.set(read());
  });
  return cell.get;
};
